import curry from '../core/curry';
import isFunction from '../predicates/isFunction';

const err = 'mapPropNames; First argument must be a function';

/**
 * Given a projection function (fn) and an object (obj)
 * it will each prop names to that function and
 * will return a new object with the transformed prop names
 */

// mapPropNames :: ((a -> b)) -> { x: c } -> { y: c }
function mapPropNames<T>(fn: (key: string) => string, obj: Record<string, T> | null): Record<string, T> | null {
  if (!isFunction(fn)) {
    throw new TypeError(err);
  }

  if (!obj) {
    return null;
  }

  return Object.entries(obj).reduce(
    (acc, [ key, val ]) => ({ ...acc, ...{ [fn(key)]: val } }),
    {} as Record<string, T>
  );
}

export default curry(mapPropNames);
